export var Topics;
(function (Topics) {
    Topics["baseIdentityActions"] = "base_identity_actions";
    Topics["payments"] = "payments";
    Topics["navigation"] = "navigation";
    Topics["wagers"] = "wagers";
    Topics["other"] = "other";
})(Topics || (Topics = {}));
export var Types;
(function (Types) {
    Types["launch"] = "launch";
    Types["registration"] = "registration";
    Types["authorization"] = "authorization";
    Types["deposit"] = "deposit";
    Types["payout"] = "payout";
    Types["bk"] = "bk";
    Types["casino"] = "casino";
    Types["toto"] = "toto";
    Types["payments"] = "payments";
    Types["wagers"] = "wagers";
    Types["promo"] = "promo";
    Types["common"] = "common";
    Types["accountChange"] = "account_change";
    Types["settings"] = "settings";
    Types["identification"] = "identification";
    Types["Euro24"] = "Euro24";
})(Types || (Types = {}));
export var Events;
(function (Events) {
    Events["historyAllMoved"] = "history_all_moved";
    Events["casinoMoved"] = "casino_moved";
    Events["betgamesMoved"] = "betgames_moved";
    Events["liveCasinoMoved"] = "live_casino_moved";
    Events["totoMoved"] = "toto_moved";
    Events["topMoved"] = "top_moved";
    Events["allBetsMoved"] = "all_bets_moved";
    Events["applicationMoved"] = "application_moved";
    Events["applicationDownload"] = "application_download";
    Events["lineMoved"] = "line_moved";
    Events["liveTabMoved"] = "live_tab_moved";
    Events["casinoGameMoved"] = "casino_game_moved";
    Events["payoutPageShow"] = "payout_page_show";
    Events["payoutPageChoice"] = "payout_page_choice";
    Events["depositPageShow"] = "deposit_page_show";
    Events["depositPageChoice"] = "deposit_page_choice";
    Events["depositInputAmount"] = "deposit_input_amount";
    Events["payoutInputAmount"] = "payout_input_amount";
    Events["searchDone"] = "search_done";
    Events["promoCurrentMoved"] = "promo_current_moved";
    Events["promoActionSelect"] = "promo_action_select";
    Events["promoMyCurrentMoved"] = "promo_my_current_moved";
    Events["promoActionStepSelect"] = "promo_action_step_select";
    Events["questClickParticipate"] = "quest_click_participate";
    Events["rulesMoved"] = "rules_moved";
    Events["howMoved"] = "how_moved";
    Events["accessMoved"] = "access_moved";
    Events["technicalSupportContacted"] = "technical_support_contacted";
    Events["feedbackMoved"] = "feedback_moved";
    Events["feedbackRating"] = "feedback_rating";
    Events["affiliateProgramMoved"] = "affiliate_program_moved";
    Events["onlineChatSupportMoved"] = "online_chat_support_moved";
    Events["onlineChatSupportRating"] = "online_chat_support_rating";
    Events["clickBanner"] = "click_banner";
    Events["clickBannerBasket"] = "click_banner_basket";
    Events["regStart"] = "reg_start";
    Events["enteredCharInReg"] = "entered_char_in_reg";
    Events["regStep2"] = "reg_step2";
    Events["regStep3"] = "reg_step3";
    Events["clickForgotPassword"] = "click_forgot_password";
    Events["viewPopUp"] = "view_pop_up";
    Events["eventViewed"] = "event_viewed";
    Events["favoUrites"] = "favoUrites";
    Events["favouritesLiveMoved"] = "favourites_live_moved";
    Events["favouritesLineMoved"] = "favourites_line_moved";
    Events["scheduleTabMoved"] = "schedule_tab_moved";
    Events["sportTypeFiltered"] = "sport_type_filtered";
    Events["timeFiltered"] = "time_filtered";
    Events["exodusFiltered"] = "exodus_filtered";
    Events["infographicsViewed"] = "infographics_viewed";
    Events["textographicViewed"] = "textographic_viewed";
    Events["matchCenterViewed"] = "matchcenter_viewed";
    Events["videoViewed"] = "video_viewed";
    Events["openVideoFullScreen"] = "open_video_full_screen";
    Events["statisticViewed"] = "statistic_viewed";
    Events["resultsLineMoved"] = "results_line_moved";
    Events["resultsLiveMoved"] = "results_live_moved";
    Events["statsMoved"] = "stats_moved";
    Events["enteredPhone"] = "entered_phone";
    Events["enteredEmail"] = "entered_email";
    Events["choseCountry"] = "chose_country";
    Events["choseCurrency"] = "chose_currency";
    Events["enteredPassword"] = "entered_password";
    Events["enteredRepeatPassword"] = "entered_repeat_password";
    Events["authorizationDone"] = "authorization_done";
    Events["smsCodeEntered"] = "sms_code_entered";
    Events["selectPhoneVerificationMethod"] = "select_phone_verification_method";
    Events["enteredCharInVerificationMethod"] = "entered_char_in_verification_method";
    Events["flashCallRequest"] = "flash_call_request";
    Events["flashCallCodeEntered"] = "flash_call_code_entered";
    Events["flashCallCodeRepeat"] = "flash_call_code_repeat";
    Events["registrationDone"] = "registration_done";
    Events["authStart"] = "auth_start";
    Events["historyDepositMoved"] = "historydeposit_moved";
    Events["historyPayoutMoved"] = "historypayout_moved";
    Events["historyPeriodSelect"] = "history_period_select";
    Events["basketMoved"] = "basket_moved";
    Events["unassignedMoved"] = "unassigned_moved";
    Events["tvgamesMoved"] = "tvgames_moved";
    Events["eventAdd"] = "event_add";
    Events["wagerDone"] = "wager_done";
    Events["clickSaleBet"] = "click_sale_bet";
    Events["confirmSaleBet"] = "confirm_sale_bet";
    Events["eventDeleted"] = "event_deleted";
    Events["basketCleared"] = "basket_cleared";
    Events["identificationStart"] = "identification_start";
    Events["identificationTypeSelection"] = "identification_type_selection";
    Events["identificationNameInput"] = "identification_name_input";
    Events["identificationLastnameInput"] = "identification_lastname_input";
    Events["identificationMiddlenameInput"] = "identification_middlename_input";
    Events["identificationDateOfBirthInput"] = "identification_date_of_birth_input";
    Events["identificationPassportInput"] = "identification_passport_input";
    Events["identificationDocumentInput"] = "identification_document_input";
    Events["identificationButtonEnter"] = "identification_button_enter";
    Events["newsMoved"] = "news_moved";
    Events["newsCategorySelection"] = "news_category_selection";
    Events["newsOpened"] = "news_opened";
    Events["newsButtonClick"] = "news_button_click";
    Events["betTypeSelect"] = "bet_type_select";
    // выше логируемые события на проде, и проверенные в карте событий https://confluence.almara.org/pages/viewpage.action?pageId=200638677
    Events["sessionStart"] = "session_start";
    Events["application"] = "application";
    Events["gotoRofit"] = "goto_rofit";
    Events["promoEnter"] = "promo_enter";
    Events["regButtonEnter"] = "reg_button_enter";
    Events["smsCodeRepeat"] = "sms_code_repeat";
    Events["backStep"] = "back_step";
    Events["pinCodeError"] = "pin_code_error";
    Events["logout"] = "logout";
    Events["depositInit"] = "deposit_init";
    Events["payoutInit"] = "payout_init";
    Events["totoDone"] = "toto_done";
    Events["casinoWagerDone"] = "casino_wager_done";
    Events["favoritesEventAdded"] = "favorites_event_added";
    Events["totoResultMoved"] = "toto_result_moved";
    Events["viewModal"] = "view_modal";
    Events["clickModal"] = "click_modal";
    Events["viewModalV2"] = "view_modal_v2";
    Events["clickModalV2"] = "click_modal_v2";
    Events["clickRulesLanding"] = "click_rules_landing";
    Events["viewLanding"] = "view_landing";
    Events["moved404"] = "404_moved";
    Events["tabClosed"] = "tab_closed";
    Events["promoMoved"] = "promo_moved";
    Events["moreMoved"] = "more_moved";
    Events["twainSportMoved"] = "twainsport_moved";
    Events["storiesAction"] = "stories_action";
    Events["storiesButtonClick"] = "stories_button_click";
    Events["viewStoriesV2"] = "view_stories_v2";
    Events["clickStoriesV2"] = "click_stories_v2";
    Events["accountEmailMoved"] = "account_email_moved";
    Events["accountPhoneMoved"] = "account_phone_moved";
    Events["accountPasswordMoved"] = "account_password_moved";
    Events["accountEmailConfirmed"] = "account_email_confirmed";
    Events["accountPhoneConfirmed"] = "account_phone_confirmed";
    Events["basketClearChanged"] = "basket_clear_changed";
    Events["balanceClearChanged"] = "balance_clear_changed";
    Events["fastWagerBasketChanged"] = "fast_wager_basket_changed";
    Events["eventsNumberChanged"] = "events_number_changed";
    Events["sortingChanged"] = "sorting_changed";
    Events["coefficientAgreementChanged"] = "coefficient_agreement_changed";
    Events["emailRegularChanged"] = "email_regular_changed";
    Events["emailImportantChanged"] = "email_important_changed";
    Events["smsImportantChanged"] = "sms_important_changed";
    Events["languageNotificationChanged"] = "language_notification_changed";
    Events["oneClickBetChanged"] = "one_click_bet_changed";
    Events["saveAlerts"] = "save_alerts";
    Events["timezoneChanged"] = "timezone_changed";
    Events["languageChanged"] = "language_changed";
    Events["nightTheme"] = "night_theme";
    Events["typeOfCoefficient"] = "type_of_coefficient";
    Events["tableWorldCup"] = "table_world_cup";
    Events["searchCasino"] = "search_casino";
    Events["cancelSearchCasino"] = "cancel_search_casino";
    Events["favouritesCasinoMoved"] = "favourites_casino_moved";
    Events["favouritesCasino"] = "favourites_casino";
    Events["casinoGroupSelect"] = "casino_group_select";
    Events["casinoCategorySelect"] = "casino_category_select";
    Events["casinoProviderSelect"] = "casino_provider_select";
    Events["clickCasinoBanner"] = "click_casino_banner";
    Events["pageEntered"] = "page_entered";
    Events["Euro24_move"] = "Euro24_move";
    Events["Euro24_tab_move"] = "Euro24_tab_move";
    Events["PL_event_lenta"] = "PL_event_lenta";
    Events["PL_event_banner"] = "PL_event_banner";
    Events["PL_event_promo"] = "PL_event_promo";
    Events["PL_event_story"] = "PL_event_story";
    Events["PL_event_lk"] = "PL_event_lk";
})(Events || (Events = {}));



// WEBPACK FOOTER //
// ./src/web-frontend-core/utils/enums/kafka.js